import { useEffect, useRef } from 'react';
export const useIntervalEffect = (callback, ms) => {
    const callbackRef = useRef(null);
    useEffect(() => {
        callbackRef.current = callback;
    }, [callback]);
    useEffect(() => {
        const intervalId = setInterval(() => {
            callbackRef.current?.();
        }, ms);
        return () => clearInterval(intervalId);
    }, [ms]);
};
